import { Amplify } from "aws-amplify";
import config from "../apiconfig.json"
import { get, post, del, put, patch } from 'aws-amplify/api';
import { fetchUserAttributes, fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import { UserRole } from "./interfaces";
import { getUrl } from "aws-amplify/storage";

// get current user information (attributes on cognito)
export const getCurrentUserInfo = async () => {
  return fetchUserAttributes();
};

// get list of users in the cognito pool
export const getUsersListAPI = async (role?) => {
  return getAPI('/users'+(role !== undefined ? '?role='+role : ''));
}

// change attributes for the specified user
export const modifyUserAPI = async (username, email, name, role) => {
    return patchAPI('/users/'+username, {body: {
        email: email, 
        email_verified: "true",
        name: name, 
        ["custom:role"]: role
    }});
}

// change email for the specified user
export const modifyEmailAPI = async (username, email) => {
    return patchAPI('/users/'+username, {body: {
        email: email, 
        email_verified: "true"
    }});
}

// create a new user in the user pool
export const createUserAPI = async (username, email, temp_password, name, role) => {
    return putAPI('/users', {body: {
        username: username, 
        email: email, 
        temp_password: temp_password, 
        name: name, 
        role: role
    }});
}

// delete an user in the user pool
export const deleteUserAPI = async (username) => {
    return delAPI('/users/'+username);
}

// block an user in the user pool
export const blockUserAPI = async (username) => {
    return postAPI('/users/'+username+'/block');
}

// unblock an user in the user pool
export const unblockUserAPI = async (username) => {
  return postAPI('/users/'+username+'/unblock');
}

// TO DO: implement API
// returns true if there are active, uncompleted tasks
export const getTaskAlertAPI = async () => {
  return getAPI('/task/alert');
}

// returns the task list of the current user
export const getTaskListAPI = async (index, pageSize, completato?) => {
  return getAPI('/task/list?index='+index+'&page_size='+pageSize+(completato !== undefined ? ('&completato='+completato): ''));
}

// returns  task list of the selected user
export const getTaskUserListAPI = async (username, index, pageSize, completato?) => {
  return getAPI('/task/list/'+username+'?index='+index+'&page_size='+pageSize+(completato !== undefined ? ('&completato='+completato): ''));
}

// returns true if there are active, uncompleted tasks
export const getTaskAPI = async (id) => {
  return getAPI('/task/'+id);
}

// change task 'completato' status
export const updateTaskStatusAPI = async (id, completato) => {
  return patchAPI('/task/'+id+"/status", {body: {
    completato: completato
  }});
}

// create new task
export const createTaskAPI = async (operatori, dataTask, link, testo, tipologia) => {
  return putAPI('/task', {body: {
      operatori: operatori, 
      dataTask: dataTask, 
      link: link, 
      testo: testo,
      tipologia: tipologia
  }});
}

// assign tasks to another user
export const assignTaskAPI = async (currentOperator, newOperator, tasks) => {
  return postAPI('/task/assign', {body: {
      current_operator: currentOperator,
      new_operator: newOperator, 
      tasks: tasks ?? []
  }});
}

// returns the badanti list
export const getBadantiListAPI = async (index, pageSize, sortKey?, order?, filters?) => {  
  return postAPI(
    '/badanti/list?index=' + index +
    '&page_size=' + pageSize +
    (sortKey !== undefined ? ('&sortKey='+sortKey) : '') +
    (order !== undefined ? ('&order='+order) : ''),
    {body: {
      filters: filters
    }}
  );
}

// returns the bozze of the current user
export const getBadantiBozzeListAPI = async (index, pageSize, sortKey?, order?, filters?) => {
  return postAPI(
    '/badanti/list?index=' + index +
    '&page_size=' + pageSize +
    '&stato=Bozza' +
    (sortKey !== undefined ? ('&sortKey='+sortKey) : '') +
    (order !== undefined ? ('&order='+order) : ''),
    {body: {
      filters: filters
    }}
  );
}

// returns the badanti list
export const getBadanteAPI = async (id) => {
  return getAPI(
    '/badanti/' + id
  );
}


// create new bozza
export const createBadanteBozzaAPI = async (badante) => {
  return putAPI('/badanti', {body: {
    ...badante,
    'Attivo': 'Bozza'
  }});
}

// update badante
export const modifyBadanteAPI = async (badante) => {
  return patchAPI('/badanti', {body: {
    ...badante
  }});
}

// check if badante exists (same name, surname and phone)
export const checkBadanteAPI = async (nome, cognome, telefono, id?) => {
  return getAPI('/badanti/check', {queryParams: {
    nome: nome,
    cognome: cognome,
    telefono: telefono,
    ...id && {id},
  }});
}

// check if badante nome cognome exists (same name and surname)
export const checkBadanteNomeCognomeAPI = async (nome, cognome, id?) => {
  return getAPI('/badanti/check/nomecognome', {queryParams: {
    nome: nome,
    cognome: cognome,
    ...id && {id},
  }});
}

// check if badante exists (same name, surname and phone)
export const checkBadanteTelefonoAPI = async (telefono, id?) => {
  return getAPI('/badanti/check/telefono', {queryParams: {
    telefono: telefono,
    ...id && {id},
  }});
}

// returns the domain values for badanti form
export const getBadantiValues = async () => {  
  return getAPI('/badanti/values');
}

// upload file
export const uploadFileAPI = async (file) => {
  return putAPI('/upload', {body: {
    ...file
  }});
}

// get file signed url
export const getFileUrl = async (path) => {
  try {
    const signedUrl = await getUrl({path: path});
    return (signedUrl.url as any);
  } catch (e) {
    console.log('GET file url failed: ', e);
    throw e;
  }
};

// returns the recensori list
export const getRecensoriListAPI = async (search?) => {  
  return getAPI(
    '/recensori/list' +
    (search !== undefined ? ('?search='+search) : '')
  );
}

// returns the recensore info
export const getRecensoreAPI = async (id) => {  
  return getAPI(
    '/recensori' +
    (id !== undefined ? ('?id='+id) : '')
  );
}

// returns the clienti list
export const getClientiListAPI = async (index, pageSize, sortKey?, order?, filters?) => {  
  return postAPI(
    '/clienti/list?index=' + index +
    '&page_size=' + pageSize +
    (sortKey !== undefined ? ('&sortKey='+sortKey) : '') +
    (order !== undefined ? ('&order='+order) : ''),
    {body: {
      filters: filters
    }}
  );
}

// returns the cliente specified by id
export const getClienteAPI = async (id) => {
  return getAPI(
    '/clienti/' + id
  );
}

// create new cliente
export const createClienteAPI = async (cliente) => {
  return putAPI('/clienti', {body: {
    ...cliente
  }});
}

// update cliente
export const modifyClienteAPI = async (cliente) => {
  return patchAPI('/clienti', {body: {
    ...cliente
  }});
}

// check if cliente exists (same name, surname and phone)
export const checkClienteAPI = async (nome, cognome, telefono, id?) => {
  return getAPI('/clienti/check', {queryParams: {
    nome: nome,
    cognome: cognome,
    telefono: telefono,
    ...id && {id},
  }});
}

// check if cliente nome cognome exists (same name and surname)
export const checkClienteNomeCognomeAPI = async (nome, cognome, id?) => {
  return getAPI('/clienti/check/nomecognome', {queryParams: {
    nome: nome,
    cognome: cognome,
    ...id && {id},
  }});
}

// check if cliente exists (same name, surname and phone)
export const checkClienteTelefonoAPI = async (telefono, id?) => {
  return getAPI('/clienti/check/telefono', {queryParams: {
    telefono: telefono,
    ...id && {id},
  }});
}

// returns the domain values for cliente form
export const getClientiValues = async () => {  
  return getAPI('/clienti/values');
}

// returns the referenti list
export const getReferentiListAPI = async (search?) => {  
  return getAPI(
    '/recensori/list' +
    (search !== undefined ? ('?search='+search) : '')
  );
}

// returns the referente info
export const getReferenteAPI = async (id) => {  
  return getAPI(
    '/recensori' +
    (id !== undefined ? ('?id='+id) : '')
  );
}

// generate contratto badante
export const generateContrattoBadante = async (id) => {
  return postAPI('/badanti/contratti/create?id='+id);
}

//
// AMPLIFY WRAPPERS
// 

// GET call
const getAPI = async (path, options?) => {
    try {
        const response = await get({ 
          apiName: config.name,
          path: path,
          options: {
            ...options,
            headers: {
              "cognito-id-token": (await fetchAuthSession()).tokens.idToken.toString()
            }
          }
        }).response;
        const body = JSON.parse(((await response.body.json()) as any).body)
        if(body.error){
          throw new APIError(body.error, body.statusCode ?? 500);
        }
        return body;
    } catch (e) {
        console.log('GET call failed: ', e);
        throw e;
    }
};

// POST call
const patchAPI = async (path, options?) => {
    try {
      const response = await patch({ 
        apiName: config.name,
        path: path,
        options: {
          ...options,
          headers: {
            "cognito-id-token": (await fetchAuthSession()).tokens.idToken.toString()
          }
        }
      }).response;
      const body = JSON.parse(((await response.body.json()) as any).body)
      if(body.error){
        throw new APIError(body.error, body.statusCode ?? 500);
      }
    } catch (e) {
      console.log('PATCH call failed: ', e);
      throw e;
    }
};

// PUT call
const putAPI = async (path, options?) => {
    try {
      const response = await put({ 
        apiName: config.name,
        path: path,
        options: {
          ...options,
          headers: {
            "cognito-id-token": (await fetchAuthSession()).tokens.idToken.toString()
          }
        }
      }).response;
      const body = await JSON.parse(((await response.body.json()) as any).body);
      if(body.error){
        throw new APIError(body.error, body.statusCode ?? 500);
      }
      return body;
    } catch (e) {
      console.log('PUT call failed: ', e);
      throw e;
    }
  };

  // POST call
  const postAPI = async (path, options?) => {
      try {
        const response = await post({ 
          apiName: config.name,
          path: path,
          options: {
            ...options,
            headers: {
              "cognito-id-token": (await fetchAuthSession()).tokens.idToken.toString()
            }
          }
        }).response;
        const body = await JSON.parse(((await response.body.json()) as any).body);
        if(body.error){
          throw new APIError(body.error, body.statusCode ?? 500);
        }
        return body;
      } catch (e) {
        console.log('POST call failed: ', e);
        throw e;
      }
    };

// DELETE call
const delAPI = async (path, options?) => {
    try {
    const response = await del({ 
        apiName: config.name,
        path: path,
        options: {
          ...options,
          headers: {
            "cognito-id-token": (await fetchAuthSession()).tokens.idToken.toString()
          }
        }
    }).response;
    if(response.statusCode > 299){
      throw new APIError("Delete error!", 500);
    }
  } catch (e) {
      console.log('DELETE call failed: ', e);
      throw e;
  }
};

// function that adds the API to the current amplify configuration
export const configureApi = () => {
    const env = process.env.REACT_APP_AMPLIFY_ENV
    const existingConfig = Amplify.getConfig();
    Amplify.configure({
      ...existingConfig,
      API: {
        ...existingConfig.API,
        REST: {
          ...existingConfig.API?.REST,
          [config.name]: {
            endpoint: config.endpoint + env,
            region: config.region
          }
        }
      },
      Storage: {
        ...existingConfig.Storage,
        S3: {
          ...existingConfig.Storage?.S3,
          bucket: env == 'master' ? config.s3bucket : config.s3bucketdev, // Replace with your bucket name
          region: config.region // Replace with your region
        }
      }
    });
}

// ERROR to throw in case the api gives us error
export class APIError extends Error {
  statusCode: number;
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, APIError.prototype);
  }
}